var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssetKuroDesktopWindowsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "windows",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.231,
    height: 57.747,
    viewBox: "0 0 54.231 57.747",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    "data-name": "Path 596",
    d: "M21.321,49.686.985,52.62A1.219,1.219,0,0,0,0,53.876V71.447A1.2,1.2,0,0,0,1.13,72.7H21.466a1.2,1.2,0,0,0,1.13-1.255V50.929a1.319,1.319,0,0,0-.384-.941A1.079,1.079,0,0,0,21.321,49.686Z",
    transform: "translate(0 -45.081)",
    fill: "#f44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    d: "M263.658,10.94a1.058,1.058,0,0,0-.89-.314l-27.115,3.929a1.219,1.219,0,0,0-.985,1.255V36.984a1.2,1.2,0,0,0,1.13,1.255h27.115a1.2,1.2,0,0,0,1.13-1.255v-25.1A1.32,1.32,0,0,0,263.658,10.94Z",
    transform: "translate(-209.812 -10.618)",
    fill: "#4caf50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    d: "M21.466,266.693H1.13A1.2,1.2,0,0,0,0,267.948V285.52a1.219,1.219,0,0,0,.985,1.255l20.336,2.947a.945.945,0,0,0,.145,0,1.2,1.2,0,0,0,1.13-1.255V267.948A1.2,1.2,0,0,0,21.466,266.693Z",
    transform: "translate(0 -236.561)",
    fill: "#2196f3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    d: "M262.912,266.693H235.8a1.2,1.2,0,0,0-1.13,1.255v21.174a1.219,1.219,0,0,0,.985,1.255l27.115,3.929a.937.937,0,0,0,.145,0,1.2,1.2,0,0,0,1.13-1.255h0v-25.1A1.2,1.2,0,0,0,262.912,266.693Z",
    transform: "translate(-209.811 -236.561)",
    fill: "#ffc107"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetKuroDesktopWindowsIcon);
export default __webpack_public_path__ + "static/media/Asset-KuroDesktopWindowsIcon.b6f225f3d924b889d1cca975c2d16ed6.svg";
export { ForwardRef as ReactComponent };